import React, { useEffect, useState } from 'react'
import { archiveGovtDept, getGovtDeptList } from '../../../actions/utilitiesAction'
import List from '../../../component/Utilities/GovtDepartment/GovtDepartmentList'
import constant from '../../../constant'
import queryString from 'query-string'
import { useLocation } from "react-router-dom";


const GovtDepartmentList = () => {

    const [list, setList] = useState([])
    const [count, setCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [keyword, setKeyword] = useState('')
    const [showLoader, setShowLoader] = useState(false)
    const location = useLocation()

    useEffect(() => {
        const qParams = queryString.parse(location.search)
        getGovtDeptLists(qParams?.p ? qParams?.p : qParams?.pageno ? qParams.pageno : currentPage)
        document.title = constant.title.GovtDepartmentList
    }, [currentPage])

    const getGovtDeptLists = (page) => {
        setShowLoader(true)
        getGovtDeptList(page).then((res) => {
            setShowLoader(false)
            setList(res.result.res)
            setCount(res.result.res1.total)
        }).catch((err) => {
            alert(err)
        })

    }
    const updateStatus = (model) => {
        archiveGovtDept(model).then((res) => {
            if (res.status) {
                getGovtDeptLists(currentPage)
            } else {
                alert(res.error)
            }
        }).catch((err) => {
            alert(err)
        })
    }
    return (
        <React.Fragment>
            <List
                list={list}
                updateStatus={updateStatus}
                getGovtDeptLists={(page => getGovtDeptLists(page))}
                count={count}
                setPage={setCurrentPage}
                keyword={setKeyword}
                showLoader={showLoader}
                cpage={currentPage}
            />
        </React.Fragment>
    )
}
export default GovtDepartmentList;